import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import {  setFinanceInvoiceStatus,getCompanyList,getFinanceInvoiceContent } from '@/api/financial-center'
import { getMessageReviewById, setMessageReviewUserByMessageReviewId } from '@/api/message'
import { Loading } from 'element-ui'
import * as math from 'mathjs'
@Component({})
export default class BackMoneyParnterInfo extends Vue {
    logShow = true
    backMoneyInfo: any = ''
    financeBackMoneyDetailList = []
    status: number = null
    approval_id: number = null // 审批查看详情id
    approval_type: string = null //审批状态 type 0-审批，1-查看
    reviewStatus: string
    opinion = '' // 审批意见
    cancleReview = false
    reviewDialog = false
    fileList = []
    fileList1 = []
    turnParagraphArr = []
    moneyCertificatesArr = []
    addDataList: any
    withdraw_id: number = null
    editFileList = []
    editFiles = {
        account: null,
        isProof: null,
        remark: null,
        invoiceTypes: null,
        invoiceTitle: null,
        invoiceCode: null,
        invoiceBank: null,
        invoiceAccount: null,
        invoiceAddress: null,
        invoicePhone: null,
        invoiceContent: '', //开票内容
        invoiceAt: '', //财务开票时间
        // financeInvoiceDetailList: null,
    }
    isRequired = false
    editFileRequired = false
    disBtn = false
    types = ''
    // 2023-2-23新增
    approvalVisible = false
    nodeType: string = null //驳回到哪个节点
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    addSignShow = false
    transferShow = false
    isShow = null
    approvalStatus = null
    approvedVisible = false // 审批通过
    approvedData = {}
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回
    backMoneyAccountOptions = []  // 收款账户
    makeInvoiceContent = []
    contentName = ''
    loading = false
    isNotReject = false

    get orderAllPrice() {
        let num = 0
        if (this.backMoneyInfo.financeInvoiceDetailList) {
            this.backMoneyInfo.financeInvoiceDetailList.map(item =>
                num = math.number(math.add(math.bignumber(num), math.bignumber(item.price ? Number(item.price) : 0)))
            )
        }
        return num
    }

    created() {
        this.approval_id = Number(this.$route.query.approval_id)
        this.types = this.$route.query.types as string
        this.getMessageReviewById()
        this.approval_type = this.$route.query.type as string
        this.reviewStatus = this.$route.query.status as string
        this.getCompanyList() // 获取收款账户
    }
    formatDate = formatDate
    // 验证当前字段是否可以编辑
    editFileShow(key: string) {
        if (this.reviewStatus !== '0' || this.approval_type !== '0') return false
        return this.editFileList.some(item => item.file === key)
    }
// 收款账户
    handleChangeAccount(val) {
        this.editFiles.account = val
        this.editFiles.invoiceContent = ''
        this.getFinanceInvoiceContent(val)
    }
    // 开票账户
    async getCompanyList() {
        const data: any = await getCompanyList()
        this.backMoneyAccountOptions = data.companyList
        this.backMoneyAccountOptions.forEach(item => {
            if (item.name == '北京集思互联教育科技有限公司' || item.name == '上海恒艾教育科技有限公司' || item.name == '北京昌意科技有限公司'||item.name == '天津集思互动教育咨询有限公司' || item.name == '蒸汽松鼠（北京）科技有限公司' || item.name == '北京汉文清雅文化有限公司'|| item.name == '青岛集思互动教育咨询有限公司') {
                item.disabled = false
            } else {
                item.disabled = true
            }
        })
    }
    getFinanceInvoiceContent(val) {
        if (val) {
            this.makeInvoiceContent = []
            getFinanceInvoiceContent({
                companyName: val
            }).then((res: any) => {
                res.financeInvoiceContent.forEach((item) => {
                    if(item.types == this.backMoneyInfo.content){
                        this.contentName = item.content
                    }
                    this.makeInvoiceContent.push({
                        label: item.content,
                        value: item.types,
                    })
                })
            })
        } else {
            this.$message.error('请选择收款账户')
        }
    }
    async getMessageReviewById() {
        this.loading = true
        await getMessageReviewById(this.approval_id,this.types).then((data: any)=>{
        this.withdraw_id = data.result.id
        this.backMoneyInfo = data.result
        this.isNotReject = data.result.isNotReject == true ? false : true
        this.isShow = data.result.isShow
        this.approvalStatus = data.result.status
        let allThisAmount =0
        data.result.financeInvoiceDetailList.forEach((item) => {
            allThisAmount += Number(item.price)
        })
        // 已通过的和审批中的按返回的结果展示（其他都减去本次开票金额）
        this.backMoneyInfo.surplusInvoicePrice = (this.isShow == '1' && this.approvalStatus == '1') || (this.isShow == '0' && this.approvalStatus == '0') ? this.backMoneyInfo.surplusInvoicePrice : this.backMoneyInfo.surplusInvoicePrice - allThisAmount
        this.editFileList = data.result.editFileList
        this.editFiles.account = this.backMoneyInfo.account
        this.editFiles.isProof = this.backMoneyInfo.isProof
        this.editFiles.remark = this.backMoneyInfo.remark
        this.editFiles.invoiceTypes = this.backMoneyInfo.types === '增值税专用发票' ? '0' : '1'
        this.editFiles.invoiceTitle = this.backMoneyInfo.title
        this.editFiles.invoiceCode = this.backMoneyInfo.invocieCode
        this.editFiles.invoiceBank = this.backMoneyInfo.bank
        this.editFiles.invoiceAccount = this.backMoneyInfo.invoiceAccount
        this.editFiles.invoiceAddress = this.backMoneyInfo.address
        this.editFiles.invoicePhone = this.backMoneyInfo.phone
        this.editFiles.invoiceContent = this.backMoneyInfo.content
        this.editFiles.invoiceAt = this.backMoneyInfo.invoiceAt
        if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.approval_type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
        this.stepNode.isFirstNode = this.backMoneyInfo.isFirstNode
        this.stepNode.isSyncEkuaibao = this.backMoneyInfo.isSyncEkuaibao
        this.stepNode.isSyncEqianbao = this.backMoneyInfo.isSyncEqianbao

        const val = this.backMoneyInfo.content
        this.getFinanceInvoiceContent(this.backMoneyInfo.account)
        this.loading = false
        }).catch(err=>{
            this.loading = false
        })
    }

    // 撤回审批cancleReview
    async cancleReviewDialogConfirm() {
        await setFinanceInvoiceStatus({ id: this.withdraw_id, action: '1' })
        this.$message.success('成功撤回审批')
        setTimeout(() => { window.close() }, 1500)
    }
    getSummaries(param: any) {
        const { columns, data } = param;
        const sums: any = [];
        columns.forEach((column: any, index: number) => {
            if (index === 0) {
                sums[index] = '总计';
                // return;
            } else if (index === 7) {
                const values = data.map((item: any) => Number(item[column.property]));
                if (!values.every((value: any) => isNaN(value))) {
                    sums[index] = values.reduce((prev: any, curr: any) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return  math.number(math.add(math.bignumber(prev), math.bignumber(curr ? Number(curr) : 0)));
                        } else {
                            return prev;
                        }
                    }, 0)
                } else {
                    sums[index] = '0'
                }
            } else {
                sums[index] = '';
            }
        });
        return sums;
    }
    // 通过
    // 1通过 2驳回
    openReviewDialog(status: number) {
        this.$set(this.approvedData, 'status', status)
        this.$set(this.approvedData, 'editFiles', this.editFiles)
        this.$set(this.approvedData, 'editFileList', this.editFileList)
        this.$set(this.approvedData, 'isRequired', this.isRequired)
        this.$set(this.approvedData, 'approveId', this.approval_id)
        this.approvedVisible = true
    }
    // 关闭审批弹窗
    closeReviewDialog() {
        this.reviewDialog = false
        this.opinion = ''
    }
    // reviewDialogConfirm() {
    //     const newObj = this.editFiles
    //     for(const key in newObj) {
    //         if(!this.editFileList.some(item => item.file === key)) delete newObj[key]
    //     }
    //     if(this.isRequired) {
    //         for(const key in newObj) {
    //             if(!newObj[key] || newObj[key].length === 0) {
    //                 this.editFileRequired = true
    //                 break;
    //             } else {
    //                 this.editFileRequired = false
    //             }
    //         }
    //     }
    //     if(this.editFileRequired && this.status == 1) {
    //         this.$message.error('请将编辑信息填写完整')
    //         return
    //     }
    //     const obj = {
    //         messageReviewId: this.approval_id,
    //         status: this.status,
    //         opinion: this.opinion,
    //         form: this.status === 1 ? newObj : {},
    //         nodeType: this.nodeType,
    //         // isRevoke: this.status === 1 ? this.isAgreeRevoke : ''
    //     }
    //     this.disBtn = true
    //     const loading = Loading.service({
    //         text: `审批${this.status === 1 ? '通过中' : '驳回中'}，请稍后`
    //     })
    //
    //     setMessageReviewUserByMessageReviewId(obj).then(() => {
    //         this.$message.success(`审批${this.status === 1 ? '通过' : '驳回'}`)
    //         this.reviewDialog = false
    //         loading.close()
    //         setTimeout(() => {
    //             window.close()
    //         }, 1500)
    //     }).catch(err=>{
    //         this.disBtn = false
    //     })
    // }

    // approvedConfirm() {
    //     const newObj = this.editFiles
    //     for(const key in newObj) {
    //         if(!this.editFileList.some(item => item.file === key)) delete newObj[key]
    //     }
    //     if(this.isRequired) {
    //         for(const key in newObj) {
    //             if(!newObj[key] || newObj[key].length === 0) {
    //                 this.editFileRequired = true
    //                 break;
    //             } else {
    //                 this.editFileRequired = false
    //             }
    //         }
    //     }
    //     if(this.editFileRequired && this.status == 1) {
    //         this.$message.error('请将编辑信息填写完整')
    //         return
    //     }
    //     const obj = {
    //         messageReviewId: this.approval_id,
    //         status: this.status,
    //         opinion: this.opinion,
    //         form: this.status === 1 ? newObj : {},
    //         // nodeType: this.nodeType,
    //         isRevoke: this.status === 1 ? this.isAgreeRevoke : ''
    //     }
    //     this.disBtn = true
    //     const loading = Loading.service({
    //         text: `审批${this.status === 1 ? '通过中' : '驳回中'}，请稍后`
    //     })
    //
    //     setMessageReviewUserByMessageReviewId(obj).then(() => {
    //         this.$message.success(`审批${this.status === 1 ? '通过' : '驳回'}`)
    //         this.reviewDialog = false
    //         loading.close()
    //         setTimeout(() => {
    //             window.close()
    //         }, 1500)
    //     }).catch(err=>{
    //         this.disBtn = false
    //     })
    // }
    // 驳回审批
    clickRejectButton(status: number) {
        this.$set(this.stepNode, 'status', status)
        this.$set(this.stepNode, 'approveId', this.approval_id)
        this.approvalVisible = true
    }

    //     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }

//    驳回弹框确认
    doApprovalConfirm(data) {
        // this.nodeType = data.rejectNode
        // this.opinion = data.reviewIdea
        // this.approvalVisible = false
        // this.reviewDialogConfirm()
        this.approvalVisible = false
    }

    /*
 * 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }


    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        // this.opinion = data.reviewIdea
        // this.isAgreeRevoke = data.isAgreeRevoke
        // this.approvedVisible = false
        // this.approvedConfirm()

        this.approvedVisible = false
    }
}
